{
  "title": "SURF RESCUE",
  "illustration": {
    "asset": "d3-cabinet-original",
    "tile": 1
  },
  "rulesheet": [
    "Complete the crew targets. Lifeboat starts a rescue.",
    "In 40 seconds, hit Rescue Bridge and both loops.",
    "Three rescues light Lifeboat for Boat Launch Multiball."
  ],
  "lighting": {
    "version": 1,
    "palette": {
      "idle": "#D5F0E2",
      "active": "#35C1CE",
      "hit": "#F0FFFA",
      "award": "#FFB84D"
    },
    "modes": {
      "rescueMission": "#56DAD1",
      "boatLaunch": "#FFB84D"
    },
    "cues": {
      "multiball": "multiball",
      "jackpot": "jackpot",
      "qualified": "bank",
      "rescued": "bank",
      "mission": "combo"
    },
    "paths": {
      "rescueBridge": "rescueBridgeArrow",
      "rescueBridgeReturn": "rescueBridgeArrow"
    }
  }
}
